export default "__VITE_ASSET__$PKy6h8b__"